// extracted by mini-css-extract-plugin
export default {"container":"AboutUs1948_container__WVJM4","paragraph":"AboutUs1948_paragraph__Mk2px"};